import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

// Componentes del Layout principal que se cargan siempre
import Layout from "./layouts/Layout";
import ProtectedRoutes from "./layouts/ProtectedRoutes";
import Cargando from './components/Cargando';
import loadable from '@loadable/component';

const LoginPhonePage = loadable(() => import("./views/LoginPhonePage"), { fallback: <Cargando /> });
const VerifySMSPage = loadable(() => import("./views/VerifySMSPage"), { fallback: <Cargando /> });

const TerminosYCondiciones = loadable(() => import("./views/TerminosYCondiciones"), { fallback: <Cargando /> });
const PoliticaDePrivacidad = loadable(() => import("./views/PoliticaDePrivacidad"), { fallback: <Cargando /> });
const TicketFormPage = loadable(() => import("./views/TicketFormPage"), { fallback: <Cargando /> });
const MisBoletosPage = loadable(() => import("./views/MisBoletosPage"), { fallback: <Cargando /> });
const UltimosBoletosUsadosPage = loadable(() => import("./views/UltimosBoletosUsadosPage"), { fallback: <Cargando /> });
const PreCheckoutPage = loadable(() => import("./views/PreCheckoutPage"), { fallback: <Cargando /> });
const ViewPurchasePage = loadable(() => import("./views/ViewPurchasePage"), { fallback: <Cargando /> });
const FichaOxxoPage = loadable(() => import("./views/FichaOxxoPage"), { fallback: <Cargando /> });
const FichaSpeiPage = loadable(() => import("./views/FichaSpeiPage"), { fallback: <Cargando /> });
const FullTicketPage = loadable(() => import("./views/FullTicketPage"), { fallback: <Cargando /> });
const UserProfilePage = loadable(() => import("./views/UserProfilePage"), { fallback: <Cargando /> });
const ChangePasswordPage = loadable(() => import("./views/ChangePasswordPage"), { fallback: <Cargando /> });
const NotFound = loadable(() => import("./views/NotFound"), { fallback: <Cargando /> });

import { useAuth } from './views/AuthProvider';

export default function AppRouter() {
    const { isAuthenticated } = useAuth();
    
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* Rutas Públicas */}
                <Route path='/iniciar' element={<LoginPhonePage />} />
                <Route path='/verifica-sms' element={<VerifySMSPage />} />
                <Route path='/terminos-y-condiciones' element={<TerminosYCondiciones />} />
                <Route path='/privacidad' element={<PoliticaDePrivacidad />} />

                {/* Rutas Protegidas */}
                <Route element={<ProtectedRoutes />}>
                    <Route path='/comprar' element={<TicketFormPage />} />
                    <Route path='/checkout' element={<PreCheckoutPage />} />
                    <Route path='/mis-boletos' element={<MisBoletosPage />} />
                    <Route path='/ultimos-boletos' element={<UltimosBoletosUsadosPage />} />
                    <Route path='/mis-datos' element={<UserProfilePage />} />
                    <Route path='/nuevo-password' element={<ChangePasswordPage />} />
                    <Route path='/ver-compra' element={<ViewPurchasePage />} />
                    <Route path='/ver-boleto-full' element={<FullTicketPage />} />
                    <Route path='/ver-ficha-oxxo' element={<FichaOxxoPage />} />
                    <Route path='/ver-ficha-spei' element={<FichaSpeiPage />} />
                </Route>

                {/* Redirección y página no encontrada */}
                <Route index element={<Navigate to={isAuthenticated ? '/comprar' : '/iniciar'} />} />
                <Route path='*' element={<NotFound />} />
            </Route>
        </Routes>
    )
}